import { slugify } from "./states";

export const SF_NEIGHBORHOODS: string[] = [
  "Downtown SF",
  "Mission District",
  "SoMa",
  "North Beach",
  "Chinatown",
  "Fisherman's Wharf",
  "Sunset District",
  "Richmond District",
  "Marina District",
  "Pacific Heights",
  "Haight-Ashbury",
  "Castro",
  "Bernal Heights",
  "Potrero Hill",
  "Bayview",
  "Presidio",
  "Treasure Island",
];

export const getSfNeighborhood = (slug: string) =>
  SF_NEIGHBORHOODS.find((n) => slugify(n) === slug);
